import { ITeam } from "../../../../../types/api";

const useCurrentTeam = (team: ITeam | undefined, currentYear: number) => {
    const currentTeamsLeague = team?.leagues?.find(l => l.year === currentYear);

    const currentTeamAgeLevel = team?.ageLevels?.find(
        a => a.year === currentYear,
    );

    return { currentTeamsLeague, currentTeamAgeLevel };
};

export default useCurrentTeam;
